"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
var LifecycleState;
(function (LifecycleState) {
    LifecycleState[LifecycleState["WillMount"] = 0] = "WillMount";
    LifecycleState[LifecycleState["DidMount"] = 1] = "DidMount";
    LifecycleState[LifecycleState["Update"] = 2] = "Update";
})(LifecycleState || (LifecycleState = {}));
/**
 * This is a drop-in replacement for useEffect
 * that will execute the first effect that happens during initial mount synchronously
 */
const useImmediateEffect = (effect, changes) => {
    const teardown = (0, react_1.useRef)(undefined);
    const state = (0, react_1.useRef)(LifecycleState.WillMount);
    // On initial render we just execute the effect
    if (state.current === LifecycleState.WillMount) {
        state.current = LifecycleState.DidMount;
        teardown.current = effect();
    }
    (0, react_1.useEffect)(() => {
        // Initially we skip executing the effect since we've already done so on
        // initial render, then we execute it as usual
        if (state.current === LifecycleState.Update) {
            return (teardown.current = effect());
        }
        else {
            state.current = LifecycleState.Update;
            return teardown.current;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, changes);
};
exports.default = useImmediateEffect;
//# sourceMappingURL=useImmediateEffect.js.map